<template>
  <div class="row">
    <div class="col-md-4 reports-tab-container">
      <div class="row report-fields-container">
        <div class="col-md-6 report-field-container">
            <label  class="form-label">{{ $tc('data_exports.payments.user') }}</label>
            <base-select
              v-model="formData.company_id"
              :options="users"
              :group-select="false"
              :searchable="true"
              :show-labels="false"
              :placeholder="$t('general.select_a_user')"
              group-values="options"
              group-label="label"
              track-by="id"
              label="name"
              @select="onSelectBuyer"
              @input="onChangeBuyer"
            />
            <span v-if="$v.formData.company_id.$error && !$v.formData.company_id.required" class="text-danger"> {{ $t('validation.required') }} </span>
        </div>
        <div class="col-md-6 report-field-container">
          <label class="report-label">{{ $t('reports.invoices.invoice_list') }}</label>
          <base-select
              v-model="formData.invoice_id"
              :options="buyerInvoicesList"
              :group-select="false"
              :searchable="true"
              :show-labels="false"
              :placeholder="$t('invoices.select_invoice')"
              group-values="options"
              group-label="label"
              track-by="id"
              label="name"
              @input="onChangeInvoice"
            />
            <span v-if="$v.formData.invoice_id.$error && !$v.formData.invoice_id.required" class="text-danger"> {{ $t('validation.required') }} </span>
        </div>
      </div>
      <div class="row report-submit-button-container">
        <div class="col-md-6">
          <base-button outline color="theme" class="report-button" @click="getReports()">
            {{ $t('reports.update_report') }}
          </base-button>
        </div>
      </div>
    </div>
    <div class="col-sm-8 reports-tab-container">
      <iframe :src="getReportUrl" class="reports-frame-style"/>
      <a class="base-button btn btn-primary btn-lg report-view-button" @click="viewReportsPDF">
        <font-awesome-icon icon="file-pdf" class="vue-icon icon-left svg-inline--fa fa-download fa-w-16 mr-2" /> <span>{{ $t('reports.view_pdf') }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import { validationMixin } from 'vuelidate'
const { required } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
      formData: {
        company_id:null,
        invoice_id:null
      },
      url: null,
      supplierSiteURL: null,
      newClientArray:[],
      buyerInvoicesArray:[],
      userType:null
    }
  },
  validations: {
    formData: {
      company_id: {
        required
      },
      invoice_id: {
        required
      }
    }
  },
  computed: {
    ...mapGetters('company', [
      'getSelectedCompany'
    ]),
    ...mapGetters('customer', [
      'customers'
    ]),

    getReportUrl () {
      return this.url
    },

    users:{
      get: function () {
        return [
            {
              label: 'Buyers',
              isDisable: true,
              options: this.newClientArray
            }
          ];
      },
      set: function (val) {
        this.formData.company_id= val
      }
    },

    buyerInvoicesList:{
      get: function () {
        return [
            {
              label: 'Invoices List',
              isDisable: true,
              options: this.buyerInvoicesArray
            }
          ];
      },
      set: function (val) {
        this.formData.invoice_id = val
      }
    },
  },
  created(){
    let data={ pagination:'no'}

    if(localStorage.getItem('role')=='super_admin'){
      this.userType='super_admin';
      this.getBuyers();
    }
  },
  mounted () {
    if (this.$route.path === '/super-admin/reports/payment-receipt-report') {
      this.$router.push('/super-admin/reports/payment-receipt-report')
    }
    this.supplierSiteURL = `/reports/payment-receipt-report/${this.getSelectedCompany.unique_hash}`
    this.getInitialReport()
  },
  methods: {
    ...mapActions('customer', [
      'fetchCustomers',
      'fetchCreateCustomer'
    ]),
    ...mapActions('invoice', [
      'fetchInvoices',
    ]),

    async getBuyers(){
      // let res= await this.fetchCustomers({pagination:'no', payement_report:'true'})
      // let customerArray = res.data.customers
      // console.log(customerArray);
      // this.newClientArray = customerArray.map(function(row) {
        //   return { id : row.default_company_id, name : row.company_name}
        // })
        let response = await this.fetchCreateCustomer()
        // console.log(response.data.achorAccountType);
        if (response.data.success) {
          this.newClientArray = response.data.achorAccountType.map(function (row) {
            return { id: row.default_company_id, name: row.name }
          })
        }
    },
    async onSelectBuyer(buyer) {
      let response = await this.fetchInvoices({buyer_company_id:buyer.id, payment_receipt_report:true})
      let invoicesArray = response.data.invoices.data;
      this.buyerInvoicesArray = invoicesArray.map(function(row) {
        return { id: row.id, name: row.invoice_number}
      })
    },
    onChangeInvoice() {
      this.formData.invoice_id = this.formData.invoice_id
    },
    onChangeBuyer () {
      this.formData.company_id = this.formData.company_id
      this.formData.invoice_id = null
    },
    async getInitialReport () {
      this.url = `${this.supplierSiteURL}`
      return true
    },
    async viewReportsPDF () {
      let data = await this.getReports()
      window.open(this.getReportUrl, '_blank')
      return data
    },
    async getReports (isDownload = false) {
      this.$v.formData.$touch()
      if (this.$v.$invalid) {
        return true
      }

      this.url = `${this.supplierSiteURL}?get_report=true`

      if (this.formData.company_id && this.formData.company_id != null) {
        this.url += `&buyer_company_id=${this.formData.company_id.id}`
      }
      if (this.formData.invoice_id && this.formData.invoice_id != null) {
        this.url += `&invoice_id=${this.formData.invoice_id.id}`
      }

      return true
    }
  }
}
</script>
